import { TopBar } from '../../top-bar/TopBar';
import { PublicOptions } from '../../../data/publicOptions';
import { Footer } from '../../footer/Footer';
import { WorkshopsList } from '../../../data/WorkshopsList';
import './Workshops.css';

export const Workshops = () => {
  return (
    <>
      <TopBar options={PublicOptions} />
      <div className="content">
        <section className="snn-page-section">
          <h1 className="snn-section-title">Workshops</h1>
          <p>
            SNN2024 se complace en anunciar la apertura de su sesión de talleres programada para el lunes,
            13 de mayo. El costo por taller es de $200 MXN en efectivo, y no se emitirán facturas—solo
            comprobante de pago. El pago debe realizarse el lunes 13 de mayo, antes de asistir al
            taller. Los participantes pueden seleccionar solo un taller, ya que el espacio es limitado. Para elegir tu
            taller, por favor llena el siguiente{' '}
            <strong>
              <a
                target="_blank"
                rel="noreferrer"
                className="email-link"
                href="https://forms.gle/MGxviBW1xEaiqzYDA"
              >
                Google form
              </a>
            </strong>
            .
          </p>
        </section>
        <div className="snn-page-section">
          {WorkshopsList.map((workshop, index) => {
            return (
              <div key={index} className="snn-panel-form-wrapper workshop-card">
                <div className="workshop-card-img-wrapper">
                  <img src={workshop.img} alt={workshop.name} />
                </div>
                <div className="workshop-card-description-wrapper">
                  <h2 className="snn-user-home-main-content-header">{workshop.name}</h2>
                  <p>{workshop.summary}</p>
                  <p>{workshop.institution}</p>
                  <div>
                    <p className="snn-user-home-main-content-large-semi">Instructors</p>
                    {workshop.instructors.map((instructor, index) => {
                      return <p key={index}>{instructor}</p>;
                    })}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <Footer />
    </>
  );
};
